<template>
  <div id="DocumentLimitTransactionNormalTerms" class="sun not-full">
    <div class="title">{{ list[0].title }}</div>
    <div class="content">{{ list[0].content }}</div>
    <v-collapse-wrapper
      ref="NormalTerms"
      @afterClose="isCollapse = false"
      @afterOpen="isCollapse = true"
    >
      <div v-collapse-content>
        <div :key="index" v-for="(item, index) in list" v-show="index > 0">
          <div class="title">{{ item.title }}</div>
          <div class="content">{{ item.content }}</div>
        </div>
      </div>
      <div v-collapse-toggle>
        <button class="collapse">
          {{ isCollapse ? '내용 접기' : '내용 더보기' }}
        </button>
      </div>
    </v-collapse-wrapper>
  </div>
</template>

<script>
export default {
  name: 'DocumentLimitTransactionNormalTerms',
  props: ['isCompleted'],
  data: function () {
    return {
      isCollapse: false,
      list: [
        {
          title: '제1조 한도거래 및 개별거래',
          content:
            '한도거래 함은 거래 기간 중 한도 금액 범위 내에서 대출금을 자유롭게 신청하고 지급받는 것을, 개별거래라 함은 대출 금액을 한도거래 기간 전 또는\n' +
            '만료일에 직접 일시 상환하거나 거래 기간까지 분할하여 상환하는 것을 말한다.',
        },
        {
          title: '제2조 상환방식',
          content:
            '1. 상점에서 입금 받는 카드매출, ㈜우아한형제들\n' +
            '    매출금액의 25%를 매 영업일에 상환하며.\n' +
            '    상환되는 금액이 각 대출금의 원금과 이자의\n' +
            '    전액을 상환하기에 부족한 경우에는,\n' +
            '    각 대출금(각 대출금의 원금과 이자의 합산액 기준)에 안분비례하여 충당된다.\n' +
            '\n' +
            '2. 상환은 개설 계좌에 따라서 펌 뱅킹 혹은\n' +
            '   자동이체납부 방식으로 납부한다. \n' +
            '\n',
        },
        {
          title: '제3조 지연손해금',
          content:
            '이자, 분할상환금, 분할상환 원리금을 대출 만기일까지 전액 상환하지 못하거나 제5조에 의한 기한의 이익을 상실한 때에는 그 다음날부터 남은 대출 잔액에 대해 연체이자율에 의한 지연손해금을 지급하기로 한다.',
        },
        {
          title: '제4조 감액·정지',
          content:
            '한도거래 여신거래의 경우 국가경제·금융사정의 \n' +
            '급격한 변동, 신용상태의 현저한 악화 혹은 상점의\n' +
            '카드매출, ㈜우아한형제들 매출금액이 하락하여 여신거래에 중대한\n' +
            '지장을 초래한다고 판단될 때에는, ㈜펀다는\n' +
            '통지에 의하여 여신(한도)금액을 줄이거나, 거래기간에 불구하고 여신실행을 일시 정지 할 수 있습니다. ',
        },
        {
          title: '제5조 기한의 이익상실',
          content: '한도거래약서 특약사항 1호에 의한다.',
        },
      ],
    }
  },
  computed: {},
  created() {},
  destroyed() {},
  methods: {
    open(refName) {
      this.$refs[refName].open()
    },
  },
}
</script>

<style lang="scss" scoped>
#DocumentLimitTransactionNormalTerms {
  padding-bottom: 30px;
  .title {
    font-weight: 600;
    font-size: 16px;
    margin-top: 30px;
  }
  .content {
    font-size: 16px;
    line-height: 1.5;
    margin-top: 13px;
  }
  button.collapse {
    width: 100%;
    height: 50px;
    font-weight: 600;
    font-size: 18px;
    color: #727d8c;
    border-radius: 24px;
    box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08);
    background-color: #ffffff;
    margin-top: 20px;
  }
}
</style>
